import { ErrorHandler, Injectable } from '@angular/core';

/**
 * Catches cross-origin "Script error." events that the browser deliberately
 * masks (filename="", lineno=0, colno=0, error=undefined) for scripts served
 * from a different origin without CORS headers.  These originate from
 * third-party microapp scripts (e.g. health-system-dashboard) and carry no
 * actionable information, so we swallow them here instead of letting Angular
 * surface them as uncaught errors in the console / crash reports.
 *
 * All other errors are forwarded to the default Angular behaviour.
 */
@Injectable()
export class PortalErrorHandler extends ErrorHandler {
  override handleError(error: unknown): void {
    if (isCrossOriginScriptError(error)) {
      return; // silently drop — no useful info available
    }
    super.handleError(error);
  }
}

function isCrossOriginScriptError(error: unknown): boolean {
  // Angular wraps ErrorEvents in an Error whose message mirrors the event.
  if (error instanceof Error && error.message === 'Script error.') {
    return true;
  }

  // provideBrowserGlobalErrorListeners() can also forward the raw ErrorEvent.
  if (typeof ErrorEvent !== 'undefined' && error instanceof ErrorEvent) {
    return error.message === 'Script error.' && !error.error;
  }

  return false;
}
